import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  EARMARKED_ACCOUNTS,
  CHILDREN_DETAILS_EDUCATION,
  ENROLLMENT_AGE,
  SPECIFIC_COLLEGE,
  COLLEGE_NAME,
  TUITION_TYPE,
  DURATION,
  SCHOOL_TYPE,
  EXPECTED_TUITION,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [1],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [2],
    title: "Partner's Name",
  },
  [AGES]: {
    iterator: [3],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [3],
    title: 'Age',
  },
  [TAX_FILING_STATE]: {
    iterator: [4, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [5, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [6, 0],
    title: 'Expenses',
  },
  [CHILDREN_DETAILS_EDUCATION]: {
    iterator: [7, 0],
    title: 'Child',
  },
  [ENROLLMENT_AGE]: {
    iterator: [7, 1],
    title: 'Enrollment Age',
  },
  [SPECIFIC_COLLEGE]: {
    iterator: [7, 2],
    title: 'Specific College',
  },
  [COLLEGE_NAME]: {
    iterator: [7, 3],
    title: 'College Name',
  },
  [TUITION_TYPE]: {
    iterator: [7, 4],
    title: 'Tuition Type',
  },
  [SCHOOL_TYPE]: {
    iterator: [7, 5],
    title: 'School Type',
  },
  [EXPECTED_TUITION]: {
    iterator: [7, 6],
    title: 'Expected Tuition',
  },
  [DURATION]: {
    iterator: [7, 7],
    title: 'Number of Years',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [8, 1],
    title: 'Earmarked Accounts',
  },
};
export default DICTIONARY;
